import * as React from 'react'
import { ConfirmModal } from '../ConfirmModal'

interface LogoutConfirmModalProps {
  isOpen: boolean
  onClose: () => void
  onConfirm: () => void
}

export const LogoutConfirmModal: React.FC<LogoutConfirmModalProps> = ({
  isOpen,
  onClose,
  onConfirm,
}) => (
  <ConfirmModal
    isOpen={isOpen}
    onClose={onClose}
    onConfirm={onConfirm}
    title="Na pewno chcesz się wylogować?"
    description="Po wylogowaniu utracisz dostęp do swoich zdjęć."
    confirmLabel="Wyloguj"
    cancelLabel="Pozostań zalogowanym"
    variant="danger"
  />
)

export default LogoutConfirmModal
